import { render, staticRenderFns } from "./StockImport.vue?vue&type=template&id=88de56da&"
import script from "./StockImport.vue?vue&type=script&lang=js&"
export * from "./StockImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports